import { INTEGRATION_STATUS } from "app/pages/sales-intelligence/pages/management/constants/constants";
import type { IntegrationStatusResponse } from "app/pages/sales-intelligence/sub-modules/management/components/types";

function isCRMIntegrated(crmData?: IntegrationStatusResponse): boolean {
    if (!crmData?.crmConnectionStatus?.syncStatus) {
        return false;
    }

    return crmData.crmConnectionStatus.syncStatus !== INTEGRATION_STATUS.NotIntegrated;
}

export default isCRMIntegrated;
